import React from 'react'
import CenteredLoadingSpinner from '../../common/CenteredLoadingSpinner'

export default function OrdinancesTabSkeleton(): JSX.Element {
  return <CenteredLoadingSpinner />
}
